import { Switch, cn } from "@heroui/react";
import React from 'react';

interface SwitchCustomProps {
  onChange: (value: boolean) => void;
  isSelected: boolean;
  classNames?: {
    base?: string;
    wrapper?: string;
    thumb?: string;
    label?: string;
    startContent?: string;
    endContent?: string;
    thumbIcon?: string;
  } | null;
}

const SwitchCustom: React.FC<SwitchCustomProps> = ({
  onChange,
  isSelected,
  classNames,
}) => {
  return (
    <Switch
      classNames={
        classNames || {
          wrapper: 'p-0 h-3 w-8 overflow-visible',
          thumb: cn(
            'w-4 h-4 border-2 shadow-lg',
            'group-data-[hover=true]:border-primary',
            // selected
            'group-data-[selected=true]:ml-4',
            // pressed
            'group-data-[pressed=true]:w-5',
            'group-data-[selected]:group-data-[pressed]:ml-4',
          ),
        }
      }
      onValueChange={onChange}
      isSelected={isSelected}
    />
  );
};

SwitchCustom.defaultProps = {
  classNames: null,
};

export default SwitchCustom;
